module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/xv8FLi/tc-custom/9781460349144.jpg?1718282942518",
      "alt": "This image is the cover for the book Emerald Mistress"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Emerald Mistress\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An international tycoon shakes up a woman’s plans for a fresh start in an Irish village in this classic romantic comedy by a "), _c('i', [_vm._v("USA Today")]), _vm._v("–bestselling author.")]), _c('br'), _c('br'), _vm._v("When Harriet Carmichael’s world comes crashing down, she’s determined to count her blessings. Forget London, her failing career and her unfaithful fiancé—an unexpected legacy of a cottage and stables in an Irish village beckons!"), _c('br'), _c('br'), _vm._v("But her fresh start is soon threatened by Rafael Cavaliere: her new neighbour and the very man who cost Harriet her job! With her heart so recently burned she’s reluctant to become another notch on his bedpost, but when passion ensnares them both, deep secrets are revealed—ones that could change their lives forever."), _c('br'), _c('br'), _c('b', [_vm._v("Originally published in 2002 as"), _c('i', [_vm._v(" Ballyflynn")]), _vm._v(", now available digitally for the first time"), _c('i', [_vm._v(".")])])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lynne Graham\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Lynne Graham lives in Northern Ireland and has been a keen romance reader since her teens. Happily married, Lynne has five children. Her eldest is her only natural child. Her other children, who are every bit as dear to her heart, are adopted. The family has a variety of pets, and Lynne loves gardening, cooking, collecting allsorts and is crazy about every aspect of Christmas.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises Limited\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0